import PrintLabelView from "./PrintLabelView";

function PrintLabel({
  id,
  printerData,
  visitorData,
  zoomPanController,
  onItemSelect,
  onItemPosChange,
  fields,
  images,
  readOnly = false,
}) {
  return (
    <PrintLabelView
      id={id}
      printerData={printerData}
      visitorData={visitorData}
      zoomPanController={zoomPanController}
      onItemSelect={onItemSelect}
      onItemPosChange={onItemPosChange}
      fields={fields}
      images={images}
      readOnly={readOnly}
    />
  );
}

export default PrintLabel;
